<template>
  <div>
    <button
      type="button"
      class="onboarding-payment-button"
      :class="{ loading: loading }"
      :disabled="loading"
      @click="initiateLinkFlow"
    >
      Bank
    </button>
    <p class="payment-note">Available U.S. only.</p>
    <div :v-if="publicToken">
      <input type="hidden" name="plaid[public_token]" :value="publicToken" />
    </div>
  </div>
</template>
<script setup>
import { ref, nextTick } from 'vue'
import axios from 'axios'

const props = defineProps({ formSelector: { type: String, required: true } })
const loading = ref(false)
const publicToken = ref(null)

async function initiateLinkFlow() {
  try {
    loading.value = true
    publicToken.value = null
    const { data } = await axios.post('/users/payment_methods/create_plaid_link_token')

    await initializePlaidWindow(data.link_token)
  } finally {
    loading.value = false
  }
}

async function initializePlaidWindow(linkToken) {
  const plaidHandler = Plaid.create({
    token: linkToken,
    onSuccess(publicTokenResponse, _metadata) {
      document.body.classList.add('overlay-enabled')
      publicToken.value = publicTokenResponse

      // Wait for the DOM to flush so the hidden input is added to the form
      nextTick(() => {
        // NOTE: ideally the entire form would be vue but until then we need to submit the form "manually"
        document.querySelector(props.formSelector).submit()
      })
    }
  })

  plaidHandler.open()
}
</script>
